import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'
export { default as AlertDescription } from './AlertDescription.vue'
export { default as AlertTitle } from './AlertTitle.vue'

export const alertVariants = cva(
  'relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current',
  {
    variants: {
      variant: {
        default: 'bg-card text-card-foreground',
        destructive:
          'text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90',
        // Status variants on design's scale: default-step border, subtle
        // surface, strong-step text (≥5.9:1 on the subtle surface).
        // Descriptions stay at full foreground strength.
        success:
          'border-success bg-success-subtle text-success-foreground *:data-[slot=alert-description]:text-success-foreground',
        warning:
          'border-warning bg-warning-subtle text-warning-foreground *:data-[slot=alert-description]:text-warning-foreground',
        info:
          'border-info bg-info-subtle text-info-foreground *:data-[slot=alert-description]:text-info-foreground',
        // The status-grammar error box (added 2026-07-19; `destructive` above
        // stays the stock card-style form). Destructive is the strong error
        // step — dark enough to be both border and text on the subtle surface.
        error:
          'border-destructive bg-destructive-subtle text-destructive *:data-[slot=alert-description]:text-destructive',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type AlertVariants = VariantProps<typeof alertVariants>
